import { AutogenModelEdiAddChgOrder, AutogenRowEdiAddChgOrder } from "./autogen/AutogenModelEdiAddChgOrder";

export class ModelEdiAddChgOrder extends AutogenModelEdiAddChgOrder<RowEdiAddChgOrder> {
	constructor() {
		super(RowEdiAddChgOrder);
	}
}

export class RowEdiAddChgOrder extends AutogenRowEdiAddChgOrder {
}